import React, { Component } from 'react';
import Home from './Home';
import DashBoard from './../DashBoard';
import MenuBar from './../HeaderComponents/MenuBar';
import withAuth from './../../auth_components/js/withAuth';

class News extends Component {
    render() {
        return (
            <div>
                <DashBoard history={this.props.history} user={this.props.user} />
                <MenuBar />
                <Home />
            </div>
        )
    }
}
export default withAuth(News);


// WEBPACK FOOTER //
// ./src/HomeComponents/News/News.js